import React from 'react'
import { Typography } from '@grammarly/badger-ui'
import cn from 'classnames'
import styles from './use-case-tab.module.scss'

export interface TabProps {
  index: number
  activeTabIndex: number
  children: React.ReactNode
  className?: string
  onTabClick: (element: HTMLButtonElement, index: number) => void
}

export const UseCaseTab: React.FC<TabProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  index,
  activeTabIndex,
  onTabClick,
  children,
  className,
  ...rest
}) => {
  const ref = React.useRef<HTMLButtonElement>(null)

  return (
    <button
      ref={ref}
      role="tab"
      key={index}
      className={cn(
        styles.tab,
        {
          [styles.active]: index === activeTabIndex,
        },
        className
      )}
      aria-selected={index === activeTabIndex}
      aria-controls={`tabpanel-${index}`}
      id={`tab-${index}`}
      onClick={() => {
        if (!ref.current) {
          return
        }
        onTabClick(ref.current, index)
      }}
      {...rest}
    >
      <Typography.TM as="span">{children}</Typography.TM>
    </button>
  )
}
